import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import DematUiPage from "./DematUiPage";
import {
  FaUserTie,
  FaGlobe,
  FaLock,
  FaPiggyBank,
  FaBuilding,
} from "react-icons/fa";
import {
  FaClipboardList,
  FaIdCard,
  FaFileAlt,
  FaCheckCircle,
} from "react-icons/fa";
import {
  Link2,
  Wallet,
  LogIn,
  Search,
  SlidersHorizontal,
  Hash,
  CheckCircle,
  FolderOpen,
  FileText,
} from "lucide-react";
import { AlertCircle, PhoneCall, ShieldOff, Share2, Edit } from "lucide-react";

import { FaUniversity } from "react-icons/fa";
import {
  Handshake, Banknote, Bell, Smartphone, Users,  Repeat, BadgeCheck, Calculator, ScrollText
} from "lucide-react";
import { ChevronDown, ChevronUp, Check,  User, MapPin, CreditCard, Landmark, DollarSign, Camera } from 'lucide-react';
import FAQSchema from "../../FAQSchema";
import AdBanner from "../AdPage/AdBanner";

const DematMainPage = () => {
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  const [activeIndex, setActiveIndex] = useState(0);
  const [activeTab, setActiveTab] = useState('eligibility');
  const [expandedSection, setExpandedSection] = useState('individual');

  const toggleSection = (section) => {
    if (expandedSection === section) {
      setExpandedSection(null);
    } else {
      setExpandedSection(section);
    }
  };
  const faqs = [
    {
      question: " What is a demat account?",
      answer:
        "A demat account (short for dematerialized account) is an electronic system used to hold and manage securities like stocks, bonds, mutual funds, and exchange-traded funds (ETFs). Instead of physical share certificates, all holdings are stored electronically, allowing for seamless transactions and safe record-keeping.",
    },
    {
      question: "Why do I need a demat account?",
      answer:
        "A demat account is essential for buying, selling, or holding securities in electronic form. It offers convenience, security, and ease of managing your investment portfolio. It is a mandatory requirement for trading in the stock market, as it eliminates the need for physical share certificates and reduces the risk of loss or damage.",
    },
    {
      question: "   How do I open a demat account?",
      answer:
        " To open a demat account, you need to choose a registered depository participant (DP), such as a bank or brokerage firm, and complete the account opening process. This typically involves submitting identity proof, address proof, a PAN card, and filling out the required forms. Once your documents are verified, you will receive your demat account details.",
    },
    {
      question: "What are the charges associated with a demat account?",
      answer:
        "  The charges for a demat account can include account opening fees, annual maintenance charges (AMC), transaction fees, and additional costs for services like dematerialization or rematerialization. It is important to understand these charges and compare them across different providers to find the best fit for your needs.",
    },
    {
      question: "Can I transfer securities between demat accounts?",
      answer:
        "Yes, you can transfer securities between demat accounts, either within the same depository or between different depositories. This process requires specific forms and may incur certain fees. Ensure you understand the procedures and costs involved before initiating a transfer.",
    },
    {
      question: "What happens to my demat account if I stop trading?",
      answer:
        " If you stop trading, your demat account remains active, but you might still incur annual maintenance charges (AMC) and other fees. You can choose to close your demat account if you no longer need it, but be sure to transfer or sell all your securities beforehand. Follow your DPs process for closing the account to avoid additional charges.",
    },
    {
      question: "What is the difference between a Demat account and a trading account?",
      answer:
        " A Demat account holds your securities in electronic form, making it easier to manage and trade. On the other hand, a trading account is used to place buy and sell orders on the stock exchange. The two accounts are interconnected, with the Demat account holding your purchased securities, and the trading account allowing you to execute trades.",
    },
    {
      question: "Can I open a Demat account online?",
      answer:
        "Yes, most brokers and depositories allow you to open a Demat account online. This process typically includes an electronic Know Your Customer (e-KYC) procedure, where you upload necessary documents like your PAN, Aadhar card, and address proof. Once verified, your account is activated, and you can start trading without visiting a physical branch.",
    },
    {
      question: "Are there any charges for opening a Demat account?",
      answer:
        " While most brokers offer free Demat account opening, some may charge for documentation or initiation. Additionally, brokers charge an Annual Maintenance Fee (AMC), which varies depending on the type of Demat account and the broker’s terms. Be sure to check all associated fees before opening the account, as they can affect your overall cost of investing.",
    },

    {
      question: "What is the minimum balance required in a Demat account?",
      answer:
        " There is typically no minimum balance requirement for holding a Demat account. However, for trading in the stock market, you need to have funds in your linked trading account to buy securities. Some brokers may ask for a minimum deposit for margin trading, but for basic investing, you can maintain any balance.",
    },
    {
      question: "Can I open a Demat account for my child or a minor?",
      answer:
        "Yes, you can open a Demat account for a minor, but it must be done under the supervision of a legal guardian. The guardian will be responsible for managing the account until the minor reaches the legal age of 18. The minor can then take control of the account and trade independently.",
    },
    {
      question: " How do I transfer securities from one Demat account to another?",
      answer:
        " To transfer securities between Demat accounts, you need to fill out a Delivery Instruction Slip (DIS) that specifies the securities and quantity being transferred. You submit this to your depository participant (DP), and they will process the transfer electronically. The transfer usually takes 1-2 business days to complete.",
    },
    {
      question: "Can I hold foreign securities in a Demat account?",
      answer:
        " Yes, as an NRI (Non-Resident Indian), you can hold foreign securities in your Demat account. You will need to open an NRI Demat account, which is compliant with the Foreign Exchange Management Act (FEMA). It’s essential to choose a depository participant that supports foreign securities, ensuring smooth transactions and regulatory compliance.",
    },
    {
      question: "What happens if my Demat account gets inactive?",
      answer:
        " If you don’t use your Demat account for an extended period (usually over a year), it will be marked inactive or dormant. To reactivate it, you may need to submit a request to your depository participant (DP). In some cases, there might be additional fees for reactivation, so it’s best to keep your account active by trading or maintaining regular activity.",
    },
    {
      question: "Can I hold mutual funds in a Demat account?",
      answer:
        "Yes, mutual funds can be held in a Demat account. When you purchase mutual funds, they are credited to your account in an electronic format. This provides a convenient way to track and manage your investments along with other securities, and eliminates the need for physical certificates, making the process more efficient and secure.",
    },
    {
      question: " Is my Demat account linked to my PAN?",
      answer:
        " Yes, your Demat account is directly linked to your PAN (Permanent Account Number) for identification and tax purposes. The PAN ensures that all your transactions are recorded under your name for tax reporting, such as capital gains tax on the sale of securities. It is mandatory to provide your PAN when opening a Demat account.",
    },
    {
      question: "What happens to my shares if I close my Demat account?",
      answer:
        " Before closing your Demat account, you need to transfer all your securities to another Demat account. The process involves submitting a transfer request to your DP, after which your securities will be transferred electronically. Once your holdings are transferred, you can proceed with account closure, and there are typically no further charges except for any pending dues.",
    },
    {
      question: "Can I have multiple Demat accounts with different brokers?",
      answer:
        " Yes, you are allowed to open multiple Demat accounts with different brokers or depositories. However, managing several accounts can become cumbersome, so it's often easier to consolidate your investments into a single account. Ensure that you maintain proper records for tax purposes and keep track of each account’s associated charges and fees.",
    },
  ];
  const DematinsuranceTypes = [
    {
      title: "Regular Demat Account",
      description:
        "This is the standard Demat account for Indian residents who trade in stocks, bonds, ETFs, and other securities. It allows seamless electronic storage and transfer of shares. Investors must link it to a trading account to buy and sell securities.",
      icon: <FaUserTie className="text-4xl text-blue-600" />,
    },
    {
      title: "Repatriable Demat Account",
      description:
        "Designed for Non-Resident Indians (NRIs), this account allows the repatriation of funds (transfer of money abroad). It must be linked with a Non-Resident External (NRE) bank account, enabling seamless fund transfers outside India while complying with RBI regulations.",
      icon: <FaGlobe className="text-4xl text-green-600" />,
    },
    {
      title: "Non-Repatriable Demat Account",
      description:
        "Also meant for NRIs, but unlike the repatriable account, it does not allow funds to be transferred abroad. It must be linked to a Non-Resident Ordinary (NRO) bank account and is used primarily for investments where funds remain within India.",
      icon: <FaLock className="text-4xl text-orange-600" />,
    },
    {
      title: "Basic Services Demat Account (BSDA)",
      description:
        "Introduced for small investors, the BSDA offers reduced maintenance charges for holdings below a specific limit (₹2 lakh). It provides an affordable way for retail investors to hold securities without incurring high fees.",
      icon: <FaPiggyBank className="text-4xl text-red-600" />,
    },
    {
      title: "Corporate or Institutional Demat Account",
      description:
        "Businesses, mutual funds, and other large institutions use corporate Demat accounts to hold securities on behalf of their investors or stakeholders. These accounts help streamline bulk trading and financial management.",
      icon: <FaBuilding className="text-4xl text-purple-600" />,
    },
  ];

  const steps = [
    {
      icon: <FaClipboardList className="text-3xl text-blue-600" />,
      title: "Choose a Depository Participant (DP) or Broker",
      description:
        "The first step is to select a Depository Participant (DP) or a brokerage firm that offers Demat account services. Compare different providers based on factors like transaction fees, annual maintenance charges, security features, and customer support to choose the most suitable option.",
    },
    {
      icon: <FaIdCard className="text-3xl text-green-600" />,
      title: "Complete the KYC Process",
      description:
        "To comply with regulatory requirements, you must complete the Know Your Customer (KYC) process. This involves providing essential identity and address proof, which can be done online through an e-KYC process in most cases.",
    },
    {
      icon: <FaFileAlt className="text-3xl text-yellow-600" />,
      title: "Fill Out the Application Form",
      description:
        "Once the KYC process is initiated, you will need to complete the application form provided by the DP. Ensure all details are accurately filled in, as any discrepancies could delay the account opening process.",
    },
    {
      icon: <FaUniversity className="text-3xl text-purple-600" />,
      title: "Submit Required Documents",
      description: (
        <>
          <p>You will be required to submit supporting documents, including:</p>
          <ul className="list-disc pl-6">
            <li>Identity proof (PAN card, Aadhaar card, Passport, or Voter ID)</li>
            <li>Address proof (Utility bill, Aadhaar card, or Bank statement)</li>
            <li>Income proof (For trading in derivatives)</li>
            <li>Bank details (Cancelled cheque for linking with a trading account)</li>
            <li>Passport-sized photographs</li>
          </ul>
        </>
      ),
    },
    {
      icon: <FaCheckCircle className="text-3xl text-red-600" />,
      title: "Verification and Account Activation",
      description: (
      <>
          <p>After submitting the necessary documents, the DP will conduct a verification process. Once your details are verified, your Demat account will be activated, and login credentials will be provided. You can then link it to a trading account to start buying and selling securities.

          </p>
          <p>Opening a Demat account is a hassle-free process that enables seamless investment in shares, mutual funds, bonds, and other financial instruments while ensuring safe and efficient electronic transactions.

</p>
          </>
      )
    },
  ];

  const brokers = [
    {
      name: "Zerodha",
      opening: "₹200",
      amc: "₹300 per year",
      brokerage: "₹0 for Equity Delivery; ₹20 per executed order",
      platform: "Kite (Web & Mobile)",
      rating: "3.7/5",
    },
    {
      name: "Groww",
      opening: "₹0",
      amc: "₹0",
      brokerage: "₹20 or 0.05% per executed order",
      platform: "Groww App (Web & Mobile)",
      rating: "3.8/5",
    },
    {
      name: "Angel One",
      opening: "₹0",
      amc: "₹240 per year",
      brokerage: "₹0 for Equity Delivery; ₹20 per executed order",
      platform: "Angel Broking App, Angel BEE",
      rating: "2.7/5",
    },
    {
      name: "Upstox",
      opening: "₹0",
      amc: "₹0 for Basic Plan; ₹249 per year for Priority Plan",
      brokerage: "₹0 for Equity Delivery; ₹20 per executed order",
      platform: "Upstox Pro (Web & Mobile)",
      rating: "2.4/5",
    },
    {
      name: "ICICI Direct",
      opening: "₹0",
      amc: "₹700 per year",
      brokerage: "0.55% for Equity Delivery; ₹20 per order",
      platform: "Trade Racer, ICICI Direct Mobile App",
      rating: "3.5/5",
    },
  ];

  const benefits = [
    {
      title: "1. Safe and Secure Storage of Securities 🛡️",
      desc: "A Demat account eliminates the risks of physical share certificates like loss or damage. All your securities are stored electronically, ensuring safety and easy tracking.",
    },
    {
      title: "2. Hassle-Free and Quick Transactions ⚡",
      desc: "With a Demat account, buying and selling shares is fast and efficient. There’s no need for paperwork, and transactions are typically settled within a day, making the process quick and seamless.",
    },
    {
      title: "3. Centralized Portfolio Management 📊",
      desc: "All your investments, from stocks to bonds, can be managed from one central location. This centralized approach helps in better tracking and managing of your portfolio.",
    },
    {
      title: "4. Easy Access and Anywhere Availability 🌐",
      desc: "Access your Demat account anytime, anywhere through online platforms and mobile apps. This flexibility allows you to monitor and trade securities on the go.",
    },
    {
      title: "5. Minimal Paperwork and Seamless Settlements 📄",
      desc: "Demat accounts reduce paperwork to a minimum, making transactions quicker and more efficient. Automatic settlement of trades ensures there are no delays.",
    },
    {
      title: "6. Cost-Efficient and Transparent 💰",
      desc: "With low maintenance charges and transparent fee structures, Demat accounts are cost-effective. All transactions are documented, providing clarity on charges and fees.",
    },
    {
      title: "7. Facilitates Corporate Benefits Automatically 🎁",
      desc: "Dividends, bonuses, and stock splits are automatically credited to your Demat account, reducing the hassle of manually tracking corporate actions.",
    },
    {
      title: "8. Nomination and Joint Holding Options 👨‍👩‍👧‍👦",
      desc: "Demat accounts offer nomination facilities and joint holding options, ensuring your assets are properly managed or passed on as needed.",
    },
    {
      title: "9. Lending and Collateral Opportunities 💼",
      desc: "You can use the securities in your Demat account as collateral for loans, unlocking the value of your investments without selling them.",
    },
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  const charges = [
    {
      title: "1. Account Opening Charges 🏁",
      details: [
        "This is a one-time fee charged at the time of opening a Demat account.",
        "While many brokers waive this fee to attract new customers, especially for basic accounts or during promotional periods, some full-service brokers may still charge it.",
        "The cost can range anywhere from ₹0 to ₹1000 depending on the broker and the type of service chosen.",
        "**Note:** Always check for hidden conditions tied to zero-cost openings, such as mandatory AMC or brokerage plans."
      ]
    },
    {
      title: "2. Annual Maintenance Charges (AMC) 🔄",
      details: [
        "Annual Maintenance Charges are levied to keep your Demat account active, even if there are no transactions.",
        "AMC typically applies to individual investors and varies depending on the type of account—basic, regular, or premium.",
        "- Basic Demat Accounts (BSDA) may have minimal or zero AMC if holdings remain below a threshold.",
        "- Regular Accounts usually attract AMC between ₹200 to ₹1000 annually.",
        "- Lifetime Free AMC Accounts are available with some brokers under special conditions or bundled offers."
      ]
    },
    {
      title: "3. Transaction Charges 💸",
      details: [
        "Every time you buy or sell shares, your DP may charge a transaction fee.",
        "- For Debit Transactions (Selling shares): Charged per transaction or per ISIN (International Securities Identification Number).",
        "- For Credit Transactions (Buying shares): Usually free, though some brokers might levy a nominal fee.",
        "Transaction charges may be flat (e.g., ₹10 per transaction) or percentage-based (e.g., 0.01% of transaction value), depending on the broker’s pricing model."
      ]
    },
    {
      title: "4. Dematerialization and Rematerialization Charges 🔄📃",
      details: [
        "Dematerialization involves converting physical share certificates into electronic form, and this service is chargeable.",
        "Rematerialization is the reverse process—converting electronic holdings back into physical certificates.",
        "Charges include per certificate processing fees and courier charges. These are generally higher due to manual processing and handling."
      ]
    },
    {
      title: "5. Custodian Fees 🏦",
      details: [
        "Custodian charges are levied for the safekeeping of securities in your Demat account.",
        "While most brokers include this under AMC or waive it entirely, some traditional brokers may charge it based on the number and type of securities held."
      ]
    },
    {
      title: "6. Pledge and Unpledge Charges 📌",
      details: [
        "When you pledge your securities for taking loans or margin trading, DPs levy charges for both pledge initiation and revocation (unpledging).",
        "These charges can vary significantly, especially in margin-enabled accounts.",
        "- Pledging Charges: Typically ₹25 to ₹50 per transaction.",
        "- Unpledging Charges: Usually similar or slightly lower."
      ]
    },
    {
      title: "7. Off-Market Transaction Charges 🔁",
      details: [
        "Off-market transfers refer to share transfers between Demat accounts outside the exchange platform, such as gifting or inheritance.",
        "These transactions attract separate fees, often higher than regular trades, due to manual processing and compliance."
      ]
    },
    {
      title: "8. Conversion Charges for Mutual Fund Units 🔃",
      details: [
        "If you convert mutual fund units from physical to electronic form (or vice versa), you may incur a conversion fee.",
        "This is relevant for investors managing mutual fund investments directly through their Demat account."
      ]
    },
    {
      title: "9. Failed Transaction Charges ❌",
      details: [
        "If a transaction fails due to insufficient balance or incorrect details, brokers may still charge a penalty.",
        "These charges ensure operational accountability and are meant to cover administrative costs."
      ]
    },
    {
      title: "10. Statement & Communication Charges 📬",
      details: [
        "While digital statements are mostly free, physical copies of account statements, holding reports, or transaction history may involve printing and courier fees."
      ]
    }
  ];
  const factors1 = [
    
    {
      title: "1. Speed of Account Opening",
      content:
        "A seamless and fast onboarding process reflects a broker’s efficiency. With Aadhaar-based e-KYC becoming the norm, most leading platforms offer same-day activation and digital processing. However, not all brokers execute this smoothly. Some may still require manual verification or physical document uploads, delaying activation. A broker that offers quick digital onboarding, real-time updates, and a user-friendly interface during the registration process will save you time and set the tone for a smooth experience ahead.",
    },
    {
      title: "2. Integration with Trading Account and Banking",
      content:
        "Convenience plays a major role in selecting a Demat account, and nothing is more convenient than a 3-in-1 account that links your bank, trading, and Demat accounts. This integration allows for automatic fund transfers, real-time settlements, and easy reconciliation of trades. If your broker doesn’t offer this, ensure that fund transfers and withdrawals between linked accounts are fast, secure, and seamless. Efficient backend processes can greatly enhance your overall investment journey.",
    },
    {
      title: "3. Reputation and Market Standing",
      content:
        "Trust is everything in the financial world. A broker's reputation, regulatory compliance, and financial standing must be considered before opening an account. Always choose a SEBI-registered broker and ensure they are connected with either NSDL or CDSL. Brokers with a long track record, transparent operations, and strong financial backing are safer choices. Avoid platforms with frequent complaints or unclear backgrounds, even if they appear attractive with their offers.",
    },
    {
      title: "4. Value-Added Features",
      content:
        "Many modern brokers offer features that go beyond just buying and selling securities. These may include daily market reports, research insights, AI-based advisory tools, tax planning suggestions, and portfolio performance analytics. While these services aren’t essential, they significantly improve the investor experience—especially for beginners who rely on guidance. Brokers that invest in these tools show a long-term commitment to their customers' financial growth.",
    },
    {
      title: "5. Mobile App Functionality",
      content:
        "With mobile-first investing on the rise, a broker's mobile app has become a critical touchpoint. The app should be lightweight, fast, and designed to handle high traffic without crashing. Essential features include biometric login, live charts, alerts, customizable watchlists, and smooth navigation. A reliable mobile app lets you stay connected to the markets from anywhere and execute trades on the go, which is especially important for time-sensitive decisions.",
    },
    {
      title: "6. Ease of Exit and Account Closure",
      content:
        "One of the most overlooked aspects of choosing a Demat account is how easy it is to exit. While account opening is aggressively advertised, some brokers complicate the closure process with long waiting periods, physical forms, and retention tactics. A good broker should offer a transparent, digital, and hassle-free account closure process. Whether you're consolidating accounts or shifting to another platform, a smooth exit process reflects the professionalism of the service provider.",
    },
    {
      title: "7. Type of Investor You Are",
      content:
        "Your investment habits play a crucial role in determining the right Demat account. If you're a long-term investor who buys and holds stocks or mutual funds, you might prioritize low maintenance charges and minimal transaction fees. On the other hand, if you're an intraday or frequent trader, real-time trading tools, low brokerage per trade, and fast execution become key. New investors, meanwhile, may look for easy-to-use interfaces, educational content, and reliable customer support. Understanding your investor profile is the foundation for making the right choice.",
    },
    {
      title: "8. Brokerage and Charges",
      content:
        "Cost is one of the most decisive elements when selecting a Demat account. While many brokers promote zero account opening charges, the real expenses are often hidden in the fine print. These may include annual maintenance charges (AMC), per trade brokerage, and miscellaneous fees for services like SMS alerts or document requests. Active traders, in particular, should watch for transaction-based charges, which can quickly erode profits. A transparent fee structure ensures there are no surprises later, and it helps you plan your investments more efficiently.",
    },
    {
      title: "9. Trading Platform and Technology",
      content:
        "In today’s digital-first world, the efficiency and reliability of a broker’s trading platform can significantly impact your investment journey. A robust platform should offer real-time data, responsive interfaces, charting tools, and seamless integration between your trading and Demat account. The ability to execute trades quickly without technical glitches is essential, especially during market volatility. A well-built platform not only improves your experience but also enhances decision-making through better analysis and speed.",
    },
    {
      title: "10. Customer Service and Support",
      content:
        "Even the most experienced investors run into issues from time to time, making efficient customer support a must-have. The ability to quickly reach support staff through phone, email, or live chat is essential when resolving technical issues or transaction errors. Brokers that offer regional language assistance, extended support hours, and dedicated relationship managers stand out in this aspect. Before opening an account, it’s wise to check reviews or community feedback on the broker’s responsiveness and service quality.",
    },
  ];
  const steps1 = [

    {
      title: "1. Log In to Your Broker’s Platform",
      icon: <LogIn className="w-6 h-6 text-purple-600" />,
      description: `Access your broker’s platform either through their website or mobile app. These platforms offer real-time data, stock search options, watchlists, charts, and other tools to help you make informed decisions. Ensure your login is secure, preferably using two-factor authentication or biometric login for added safety.`,
    },
    {
      title: "2. Search for the Stock You Want to Buy",
      icon: <Search className="w-6 h-6 text-yellow-600" />,
      description: `Use the search bar to find the stock you're interested in. You can search by company name or ticker symbol. Once selected, you’ll be able to see the stock’s current market price, historical performance, market depth, and other relevant data. Review this information to decide whether it’s the right time to invest.`,
    },
  
    {
      title: "3. Specify Quantity and Duration",
      icon: <Hash className="w-6 h-6 text-indigo-600" />,
      description: `Enter the number of shares you wish to purchase. You can also choose the duration for which the order will remain active—either Day Order (valid for the trading day only) or GTC (Good Till Cancelled), depending on your broker’s platform. Once filled, double-check all details before proceeding.`,
    },

    {
      title: "4. Keep Transaction Records and Contract Notes",
      icon: <FileText className="w-6 h-6 text-gray-600" />,
      description: `After every successful trade, you’ll receive a contract note via email detailing the price, quantity, charges, and taxes. This document is important for taxation, audit, and record-keeping. Make sure you store or archive these emails for future reference.`,
    },
    {
      title: "5. Fund Your Trading Account",
      icon: <Wallet className="w-6 h-6 text-green-600" />,
      description: `Before placing an order, you need to ensure your trading account has sufficient funds. You can transfer money online from your linked bank account via UPI, net banking, or a payment gateway. The added funds appear instantly or within minutes, depending on the payment mode used. Always ensure your account is funded in advance, especially during volatile market hours.`,
    },
    {
      title: "6. View Holdings in Your Demat Account",
      icon: <FolderOpen className="w-6 h-6 text-pink-600" />,
      description: `Post-execution, the shares will be reflected in the Holdings or Portfolio section of your platform. These shares are now stored securely in your Demat account. You can track their market value, set alerts, or plan your next move accordingly. Some platforms also offer insights like dividend updates, P&L analysis, and tax reports.`,
    },
    {
      title: "7. Place the Order and Monitor Its Status",
      icon: <CheckCircle className="w-6 h-6 text-emerald-600" />,
      description: `After confirming, place the order. Your trading platform will process it instantly if it's a market order. You can monitor its status in the Order Book or Trade Book section. For limit orders, the order remains pending until the stock hits your target price. Once executed, the corresponding shares will be credited to your Demat account within T+1 days (Trade Day plus 1 day) as per the current SEBI settlement cycle.`,
    },
 

    {
      title: "8. Link Your Demat Account with a Trading Account",
      icon: <Link2 className="w-6 h-6 text-blue-600" />,
      description: `A Demat account alone doesn’t allow you to buy or sell shares—it acts like a digital locker that stores your holdings. You also need a trading account that connects you to the stock exchange. Most brokers now offer 2-in-1 or 3-in-1 accounts (Demat + Trading + Bank) to ensure seamless transactions. Once linked, your trading account will be used to place orders, while the Demat account will hold the shares you purchase.`,
    },

    {
      title: "9. Choose the Order Type",
      icon: <SlidersHorizontal className="w-6 h-6 text-red-600" />,
      description: `Next, you’ll need to choose the type of order you want to place:\n\nMarket Order: Buys the stock at the current market price. It executes instantly but may vary slightly from the displayed price due to fluctuations.\n\nLimit Order: Buys the stock only at a specific price set by you. The order will be executed only if the stock reaches that price.\n\nStop Loss Order: Commonly used to limit losses, this order triggers a market or limit order once a stock reaches a specified price.\n\nSelect the order type that aligns with your investment strategy and risk appetite.`,
    },
  ];
  const chargesNew = [
    {
      icon: <AlertCircle className="text-red-500 w-6 h-6" />,
      title: "Failed Transaction Charges",
      description: `In cases where a sell order is placed without sufficient holdings or when shares aren’t delivered in time, brokers may levy a failed transaction or delivery penalty. This happens most commonly due to user error, unsettled trades, or delays in internal transfers. These penalties may also include exchange-imposed fines.`,
    },
    {
      icon: <PhoneCall className="text-yellow-500 w-6 h-6" />,
      title: "Call & Trade Charges",
      description: `If you place trades via customer service or through a call center instead of the app or online portal, brokers—especially discount ones—often charge a flat fee per order. This cost can quietly build up for those who frequently need offline support to execute trades.`,
    },
    {
      icon: <FileText className="text-blue-500 w-6 h-6" />,
      title: "Statement or Document Request Charges",
      description: `Requesting physical copies of account statements, contract notes, or holding summaries can incur courier and printing fees. These are rarely needed, but when they are—for audits, loans, or taxation purposes—they can come with per-page or per-dispatch costs, which are not always clearly mentioned.`,
    },
    {
      icon: <ShieldOff className="text-purple-500 w-6 h-6" />,
      title: "Dormant Account Reactivation Charges",
      description: `If your Demat account remains unused for a prolonged period—usually 12 to 24 months—it may be marked dormant. Reactivating such accounts often involves a fee and may require you to complete re-KYC formalities. This can be a hidden cost for passive or long-term investors who trade infrequently.`,
    },
    {
      icon: <Share2 className="text-green-500 w-6 h-6" />,
      title: "Off-Market Transfer Charges",
      description: `Off-market transfers, such as gifting stocks to family or transferring holdings between personal accounts, are charged differently than regular trades. These charges are usually levied per ISIN or as a percentage of the transaction value. They are not always part of standard brokerage disclosures and can catch investors off guard.`,
    },
    {
      icon: <Edit className="text-pink-500 w-6 h-6" />,
      title: "Modification Fees for Account Details",
      description: `Updating your KYC details—like your registered mobile number, email ID, bank account, or address—may come with small processing fees. While digital-first brokers may waive these, traditional brokers or those requiring physical documents may levy charges, especially if changes are frequent.`,
    },
  ];
 
  const tips = [
   
    {
      icon: <Banknote className="text-green-500 w-6 h-6" />,
      title: "Avoid Frequent Pledging and Unpledging",
      content: `Margin traders often pledge their securities to avail extra funds. However, repeated pledging and unpledging can incur significant fees over time. To reduce this cost, plan your margin requirements in advance and consolidate your pledging activity. Some brokers also offer zero pledge fees as part of premium plans—exploring those options could lead to long-term savings.`,
    },
    {
      icon: <Bell className="text-red-500 w-6 h-6" />,
      title: "Monitor Account Activity to Avoid Dormancy",
      content: `Inactive Demat accounts are often marked dormant and may require reactivation fees and additional KYC procedures. To avoid these, make sure you execute at least one transaction annually—buying or selling even a small quantity can keep your account active and save you from dormant reactivation charges later.`,
    },
    {
      icon: <Repeat className="text-pink-500 w-6 h-6" />,
      title: "Be Cautious With Off-Market Transfers",
      content: `Off-market transactions—like gifting shares or moving them between family members' accounts—can attract higher fees compared to regular exchange-based trades. Instead of frequent small transfers, try to batch and plan them in advance to minimize the number of off-market instructions and thereby reduce cumulative charges.`,
    },
  
    {
      icon: <FileText className="text-blue-500 w-6 h-6" />,
      title: "Avoid Physical Statements and Stick to Email Alerts",
      content: `Depositories like NSDL and CDSL offer both SMS and email alerts for transaction updates. While SMS services might carry nominal annual fees, email alerts are often free and just as effective. Avoiding physical statements and updates not only helps reduce courier costs but is also environmentally conscious and faster.`,
    },
    {
      icon: <Calculator className="text-lime-500 w-6 h-6" />,
      title: "Use Brokerage Calculators Before Every Trade",
      content: `To avoid surprises, always calculate your trade costs—including brokerage, taxes, SEBI charges, and DP charges—before executing a transaction. Many brokers offer built-in brokerage calculators. Using them helps you understand the net cost of each trade, especially in high-frequency or intraday strategies, allowing you to adjust your actions to minimize fees.`,
    },
    {
      icon: <ScrollText className="text-cyan-500 w-6 h-6" />,
      title: "Review Your Demat Statements Regularly",
      content: `A monthly or quarterly review of your account statement can help you spot any unusual or excess deductions. Cross-checking each charge ensures you're only paying for services you've actually used. If you find any unexplained fees, reach out to customer support—many brokers reverse mistaken charges upon prompt reporting.`,
    },
    {
      icon: <BadgeCheck className="text-orange-500 w-6 h-6" />,
      title: "Understand the AMC Waiver Conditions",
      content: `Some brokers waive the Annual Maintenance Charges for the first year or even for the lifetime if certain conditions are met—such as maintaining a minimum balance or investing in partner mutual funds. Be sure to check the fine print to see if you can qualify for such waivers and benefit from zero AMC plans by fulfilling simple eligibility conditions.`,
    },
    {
      icon: <Users className="text-purple-500 w-6 h-6" />,
      title: "Consolidate Multiple Demat Accounts",
      content: `Maintaining multiple Demat accounts with different brokers may result in duplicate AMCs and more transaction fees. By consolidating your holdings into one or two well-chosen accounts, you can streamline costs and gain better control over your investments. Transferring shares between accounts does involve a one-time off-market transfer fee, but the long-term savings on maintenance and platform fees often outweigh it.`,
    },
   
    {
      icon: <Smartphone className="text-yellow-500 w-6 h-6" />,
      title: "Use Online Channels Instead of Offline Support",
      content: `Many brokers impose a charge for services like placing orders via phone or requesting statements physically. By using the app or online trading portal for all activities—whether it’s placing trades, downloading statements, or modifying account details—you can steer clear of unnecessary offline service fees. Opting for e-statements also helps avoid courier and documentation charges.`,
    },
    {
      icon: <Handshake className="text-indigo-500 w-6 h-6" />,
      title: "Choose the Right Broker Based on Your Usage",
      content: `The first step in reducing Demat charges is selecting a broker that aligns with your investment habits. If you're a long-term investor who trades occasionally, opt for a broker offering zero Annual Maintenance Charges (AMC) and low custody fees. Active traders, on the other hand, should look for platforms with competitive brokerage rates, real-time analytics, and minimal transaction charges. Don’t fall for flashy discounts—read the complete tariff sheet to ensure hidden charges aren’t lurking in the fine print.`,
    },
  ];
  const ad = {
    image: "/assets/homeadd.png",
    link: "https://play.google.com/store/apps/details?id=com.myairtelapp&pcampaignid=web_share",
    altText: "Advertisement",
  };
  const ad2 = {
    image: "/assets/slider.png",
    link: "https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share",
    altText: "Advertisement",
  };

  const ad3 = {
    image: "/assets/popad.png",
    link: "https://play.google.com/store/apps/details?id=com.popclub.android&pcampaignid=web_share",
    altText: "Advertisement",
  };
  return (
    <>
      <Helmet>
        <title>
        Open a Demat Account Online – Compare Brokers & Charges
        </title>
        <meta
          name="description"
          content="Learn how to open a Demat account online in India. Compare brokers, account charges, features, and benefits in one place."
        />
        <meta
          name="keywords"
          content="what is demat and trading account, what is demat account meaning"
        />
        <link rel="canonical" href="https://thefinmaster.com/demat" />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <nav className="text-gray-500 text-sm my-2 ml-14 mt-20" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800">
              Home
            </Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>
          <li className="flex items-center">
            <span className="text-gray-500">Demat</span>
          </li>
        </ol>
      </nav>

      <div className="w-full flex flex-col items-center lg:px-4 ">
        <div className="w-full flex justify-center">
          <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
            <div className="w-full sm:w-[50%]">
              <div className="w-[90%]">
                <h1 className="text-4xl md:text-5xl font-bold mt-6 md:mt-0 md:pl-0 pl-6">
                  <span className="text-blue-600">
                    Open a free Demat Account
                  </span>{" "}
                  Invest Smarter, Manage Easier.
                </h1>
              </div>
            </div>
            <div className="w-full sm:w-[50%]">
              <img
                className="w-full max-w-full"
                src="../assets/dematlive.png"
                alt="Open a free Demat Account"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="shadow-lg rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
        <p className="text-lg md:text-base lg:text-lg text-center">
          A Demat account isn't just for seasoned investors. Whether you're a
          beginner or a seasoned pro, a Demat account opens doors to a vast
          array of investment options. Explore equities, mutual funds, Exchange
          Traded Funds (ETFs), and more, all within a single platform.
          TheFinMaster.com helps you to make informed decisions. Get started
          today and unlock the potential of your Demat account !
        </p>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
      <AdBanner displayOrder="1" />
        </div>
      <div>
        <DematUiPage />
      </div>
   
      <div className="flex justify-center items-center  p-4 mt-10">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            What is a Demat Account ?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            A Demat Account (short for Dematerialized Account) is an electronic
            account that allows investors to hold, buy, and sell financial
            securities like stocks, bonds, mutual funds, and exchange-traded
            funds (ETFs) in digital form. It eliminates the need for physical
            share certificates, making trading seamless, secure, and efficient.
            owner-driver.
          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
            When you purchase shares in the stock market, they are stored
            electronically in your Demat Account, just like money is stored in a
            bank account. Similarly, when you sell shares, they are debited from
            your account. Regulated by depositories such as NSDL (National
            Securities Depository Limited) and CDSL (Central Depository Services
            Limited), Demat Accounts ensure the safekeeping and easy transfer of
            securities.
          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
            A Demat Account is essential for anyone looking to trade or invest
            in the stock market, as it simplifies transactions, reduces
            paperwork, and minimizes risks associated with physical share
            certificates, such as loss, theft, or damage.{" "}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
          Key Stats
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2">
        Choosing the right car insurance is crucial for financial security on the road. 
        Here are the three main types of car insurance plans:
      </p> */}

        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">📈</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Total Number of Demat Accounts
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              The cumulative count of Demat accounts reached approximately 185
              million by the end of 2024, marking a substantial increase from
              previous years.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">💰</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Value of Securities Held
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              As of September 2024, the total value of securities held in Demat
              accounts with Central Depository Services Limited (CDSL) reached
              approximately ₹78.26 lakh crore (₹78.26 trillion).
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🏦</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Depository Participants (DPs) Network
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              National Securities Depository Limited (NSDL) has established a
              vast network of 63,343 DP service centers across India,
              facilitating widespread access to depository services for
              investors.
            </p>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
          <div  className="w-full max-w-5xl">
              <AdBanner displayOrder="2" />
              </div>
            
        </div>


        <section className="bg-white py-4 px-6 md:px-14">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-4">
        Types of Demat Accounts
        </h2>
        <p className="text-lg text-center text-gray-600 mb-4">
        A Demat account is essential for trading and holding securities in
          electronic form. Based on the investor's profile and trading
          requirements, different types of Demat accounts are available. Here’s
          a breakdown of the primary types:{" "} </p>
    </div>
    </section>
      <div className="p-8 max-w7xl mx-auto">
        {/* Header */}
        {/* <h2 className="text-3xl font-bold text-center text-gray-900 mb-6">
          Types of Demat Accounts
        </h2>
        <p className="text-lg text-center text-gray-600 mb-10">
          A Demat account is essential for trading and holding securities in
          electronic form. Based on the investor's profile and trading
          requirements, different types of Demat accounts are available. Here’s
          a breakdown of the primary types:{" "}
        </p> */}

        {/* Insurance Cards */}
        <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-8">
          {DematinsuranceTypes.map((insurance, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-center"
            >
              <div className="flex justify-center mb-4">{insurance.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {insurance.title}
              </h3>
              <p className="text-gray-600">{insurance.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto p-6 ">
        <h2 className="text-2xl md:text-3xl  font-bold text-center text-gray-800 mb-4">
          How to Open a Demat Account: A Step-by-Step Guide
        </h2>
        <p className="text-lg text-center text-gray-600 mb-4">
          A Demat account simplifies the process of holding and trading
          securities electronically, ensuring convenience and security. Opening
          a Demat account is a straightforward process, and here’s a
          step-by-step guide to help you get started: {/* Steps Section */}
        </p>
        <div className="grid md:grid-cols-2 gap-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-4 border rounded-lg shadow-sm hover:shadow-md transition"
            >
              <div>{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800">
                  {step.title}
                </h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Broker Comparison Table */}
        <h2 className=" text-2xl md:text-3xl  font-bold text-center text-gray-800 mt-12 mb-6">
          Comparison Between Major Demat Brokers
        </h2>
        {/* <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-200 text-left">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 border">Broker</th>
                <th className="p-3 border">Account Opening Charges</th>
                <th className="p-3 border">Annual Maintenance Charges (AMC)</th>
                <th className="p-3 border">Brokerage Fees</th>
                <th className="p-3 border">Trading Platforms</th>
                <th className="p-3 border">Customer Ratings</th>
              </tr>
            </thead>
            <tbody>
              {brokers.map((broker, index) => (
                <tr key={index} className="border">
                  <td className="p-3 border">{broker.name}</td>
                  <td className="p-3 border">{broker.opening}</td>
                  <td className="p-3 border">{broker.amc}</td>
                  <td className="p-3 border">{broker.brokerage}</td>
                  <td className="p-3 border">{broker.platform}</td>
                  <td className="p-3 border">{broker.rating}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div> */}
         <div className="hidden lg:block overflow-x-auto">
        <table className="w-full border border-gray-300 text-left text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 border">Broker</th>
              <th className="p-3 border">Account Opening Charges</th>
              <th className="p-3 border">AMC</th>
              <th className="p-3 border">Brokerage Fees</th>
              <th className="p-3 border">Trading Platforms</th>
              <th className="p-3 border">Rating</th>
            </tr>
          </thead>
          <tbody>
            {brokers.map((broker, index) => (
              <tr key={index} className="border">
                <td className="p-3 border">{broker.name}</td>
                <td className="p-3 border">{broker.opening}</td>
                <td className="p-3 border">{broker.amc}</td>
                <td className="p-3 border">{broker.brokerage}</td>
                <td className="p-3 border">{broker.platform}</td>
                <td className="p-3 border">{broker.rating}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Box View */}
      <div className="block lg:hidden space-y-6">
        {brokers.map((broker, index) => (
          <div key={index} className="border rounded-xl shadow p-4 space-y-3 bg-white">
            <div className="bg-gray-100 rounded-md p-2"><strong>Broker:</strong> {broker.name}</div>
            <div className="bg-gray-100 rounded-md p-2"><strong>Account Opening:</strong> {broker.opening}</div>
            <div className="bg-gray-100 rounded-md p-2"><strong>AMC:</strong> {broker.amc}</div>
            <div className="bg-gray-100 rounded-md p-2"><strong>Brokerage Fees:</strong> {broker.brokerage}</div>
            <div className="bg-gray-100 rounded-md p-2"><strong>Trading Platforms:</strong> {broker.platform}</div>
            <div className="bg-gray-100 rounded-md p-2"><strong>Rating:</strong> {broker.rating}</div>
          </div>
        ))}
      </div>
    
      </div>

      <section className="bg-white py-10 px-6 md:px-14">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-4">
        Benefits of a Demat Account
        </h2>
        <p className="text-lg text-center text-gray-600 mb-4">
        A Demat account offers numerous advantages, making it a crucial tool for today’s investors. It not only simplifies the process of managing and trading securities but also brings added security, convenience, and transparency. Let’s explore the key benefits of having a Demat account.
        </p>
        <div className="space-y-6">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gray-50 p-6 rounded-2xl shadow hover:shadow-md transition"
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {benefit.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">{benefit.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
   
    <section className="bg-white py-6 px-6 md:px-14">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-4">
           Types of Demat Account Charges
        </h2>
        <p className="text-lg text-center text-gray-600 mb-10">
        When opening and maintaining a Demat account, understanding the structure of charges involved is essential. These charges vary by broker, account type, and services offered. Being aware of these costs can help investors make informed decisions and avoid unexpected deductions. Here's a deep dive into the various types of Demat account charges typically levied by Depository Participants (DPs):        </p>
        <div className="space-y-8">
          {charges.map((charge, index) => (
            <div
              key={index}
              className="bg-gray-50 p-6 rounded-2xl shadow hover:shadow-md transition"
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {charge.title}
              </h3>
              <ul className="list-disc pl-5 text-gray-700 space-y-2">
                {charge.details.map((item, idx) => (
                  <li key={idx} className={item.startsWith("**Note:**") ? "font-medium text-yellow-600" : ""}>
                    {item.replace("**Note:**", "🔔 Note:")}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  
    <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
    <section className="bg-white dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-gray-900 dark:text-white">
          Factors to Consider When Choosing a Demat Account
        </h2>
        <p className="text-lg text-center text-gray-600 mb-10">
        Selecting the right Demat account is a crucial decision that can impact your investing experience, trading efficiency, and long-term portfolio management. While most Demat accounts may seem similar at first glance, subtle differences in services, charges, and digital infrastructure can make a significant difference. Here are the key factors every investor should evaluate before opening a Demat account:
        </p>
                <div className="grid md:grid-cols-2 gap-8">
          {factors1.map((factor, index) => (
            <div
              key={index}
              className="bg-gray-100 dark:bg-gray-800 p-6 rounded-2xl shadow-md hover:shadow-xl transition duration-300"
            >
              <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-3">
                {factor.title}
              </h3>
              <p className="text-gray-700 dark:text-gray-300 text-base leading-relaxed">
                {factor.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
    <section className="bg-white dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-16">
      <div className="max-w-7xl mx-auto">
      <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-8">
          How to Buy Shares Through a Demat Account
        </h2>
        <p className="text-lg text-center text-gray-600 mb-10">
        Buying shares through a Demat account is a simple, streamlined process that empowers investors to build their portfolio from anywhere, anytime. While the steps may vary slightly depending on the platform or broker, the core process remains largely the same. Whether you are a beginner or just looking to brush up, here’s a step-by-step breakdown of how to buy shares through your Demat account:
          </p>
        <div className="grid md:grid-cols-2 gap-6">
          {steps1.map((step, index) => (
            <div
              key={index}
              className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-6 shadow-sm hover:shadow-md transition"
            >
              <div className="flex items-start gap-4 mb-3">
                <div className="p-2 bg-white dark:bg-gray-700 rounded-md shadow">{step.icon}</div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                  {step.title}
                </h3>
              </div>
              <p className="text-base text-gray-700 dark:text-gray-300 whitespace-pre-line">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-white py-6 px-6 md:px-14">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-8">
        Hidden Charges to Watch Out For
        </h2>
        <p className="text-lg text-center text-gray-600 mb-4">
        Even with a transparent pricing structure, several lesser-known fees often go unnoticed until you're actively using your Demat account. These hidden charges can affect your returns, especially for active or long-term investors. While some may seem small, their cumulative impact makes it important to stay alert. Here are the hidden charges not commonly highlighted but crucial to watch for:
        </p>
   </div>
   </section>
    <section className="bg-white dark:bg-gray-900 py-4 px-8 sm:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {/* <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-8">
          Hidden Charges to Watch Out For
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-10 text-center max-w-2xl mx-auto">
          Even with a transparent pricing structure, several lesser-known fees often go unnoticed until you're actively using your Demat account. These hidden charges can affect your returns, especially for active or long-term investors. While some may seem small, their cumulative impact makes it important to stay alert. Here are the hidden charges not commonly highlighted but crucial to watch for:

        </p> */}

        <div className="relative border-l border-gray-300 dark:border-gray-700">
          {chargesNew.map((item, index) => (
            <div key={index} className="mb-10 ml-6">
              <span className="absolute -left-3 flex items-center justify-center w-6 h-6 bg-white dark:bg-gray-950 ring-2 ring-gray-300 dark:ring-gray-700 rounded-full">
                {item.icon}
              </span>
              <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{item.title}</h3>
              <p className="text-base text-gray-600 dark:text-gray-300">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    
    <section className="bg-white py-6 px-6 md:px-14">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-8">
        How Can I Reduce My Demat Charges?
        </h2>
        <p className="text-lg text-center text-gray-600 mb-4">
        While a Demat account is essential for seamless investing in the digital age, the associated charges—if not monitored—can quietly eat into your profits. Fortunately, with a bit of awareness and planning, many of these expenses can be significantly reduced or even avoided altogether. Here’s how you can minimize your Demat-related costs and improve your overall investing efficiency:              </p>
   </div>
   </section>
    <section className="bg-white dark:bg-gray-900 py-8 px-4 sm:px-6 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {/* <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-8">
          How Can I Reduce My Demat Charges?
        </h2>
        <p className="text-center text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto mb-12">
         </p> */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
          {tips.map((tip, index) => (
            <div key={index} className="bg-gray-50 dark:bg-gray-900 rounded-2xl shadow-sm p-6 transition hover:shadow-md">
              <div className="flex items-center space-x-4 mb-3">
                <div className="p-2 bg-white dark:bg-gray-800 rounded-full shadow">
                  {tip.icon}
                </div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                  {tip.title}
                </h3>
              </div>
              <p className="text-base text-gray-600 dark:text-gray-300">{tip.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-6 ">
          Documents Required to Open a Demat Account
          </h2>
          <p className="text-center text-lg text-gray-600 dark:text-gray-300 max-w-4xl mx-auto">
          The account opening process is paperless with most modern brokers, but it still requires specific documents for KYC (Know Your Customer) verification. These documents are mandatory under SEBI guidelines and help ensure the legitimacy of account holders. Here's what you typically need:
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="flex border-b border-gray-200 mb-8">
          <button
            className={`px-4 py-2 font-medium text-sm sm:text-base sm:px-8 sm:py-4 ${
              activeTab === 'eligibility'
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('eligibility')}
          >
            Eligibility
          </button>
          <button
            className={`px-4 py-2 font-medium text-sm sm:text-base sm:px-8 sm:py-4 ${
              activeTab === 'documents'
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('documents')}
          >
            Required Documents
          </button>
        </div>

        {/* Eligibility Content */}
        {activeTab === 'eligibility' && (
          <div className="mb-12">
            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
              <p className="text-gray-700 mb-4">
              Opening a Demat account is the first step towards participating in India’s capital markets, but before you can begin trading or investing, you must meet certain eligibility criteria and provide the necessary documentation. This process ensures transparency, security, and compliance with regulatory norms laid out by SEBI and depositories like NSDL and CDSL.
              </p>

              {/* Eligibility Categories */}
              <div className="mt-8 space-y-4">
                {/* Individual Category */}
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  <button
                    className="w-full flex justify-between items-center p-4 bg-gray-50 hover:bg-gray-100 focus:outline-none"
                    onClick={() => toggleSection('individual')}
                  >
                    <div className="flex items-center">
                      <User className="h-5 w-5 text-blue-500 mr-2" />
                      <span className="font-medium">Indian Citizens</span>
                    </div>
                    {expandedSection === 'individual' ? (
                      <ChevronUp className="h-5 w-5 text-gray-500" />
                    ) : (
                      <ChevronDown className="h-5 w-5 text-gray-500" />
                    )}
                  </button>
                  
                  {expandedSection === 'individual' && (
                    <div className="p-4 bg-white">
                      <ul className="ml-8 list-disc text-gray-700 space-y-2">
                        <li>Any Indian resident above 18 years of age can open a Demat account by submitting valid identity and address proof as per SEBI guidelines.
                        </li>
                        {/* <li>Should have valid proof of identity and address</li>
                        <li>Must have a PAN card</li>
                        <li>Must have an active bank account</li> */}
                      </ul>
                    </div>
                  )}
                </div>
                
                {/* Minor Category */}
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  <button
                    className="w-full flex justify-between items-center p-4 bg-gray-50 hover:bg-gray-100 focus:outline-none"
                    onClick={() => toggleSection('minor')}
                  >
                    <div className="flex items-center">
                      <User className="h-5 w-5 text-green-500 mr-2" />
                      <span className="font-medium">Minors (Below 18 years)</span>
                    </div>
                    {expandedSection === 'minor' ? (
                      <ChevronUp className="h-5 w-5 text-gray-500" />
                    ) : (
                      <ChevronDown className="h-5 w-5 text-gray-500" />
                    )}
                  </button>
                  
                  {expandedSection === 'minor' && (
                    <div className="p-4 bg-white">
                      <ul className="ml-8 list-disc text-gray-700 space-y-2">
                        <li>Demat accounts can be opened in the name of minors. However, these must be operated by a guardian until the child becomes an adult.
                        </li>
                        {/* <li>Must be operated by a guardian until adulthood</li>
                        <li>Guardian must provide their KYC documents</li>
                        <li>Minor's birth certificate is required</li> */}
                      </ul>
                    </div>
                  )}
                </div>
                
                {/* NRI Category */}
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  <button
                    className="w-full flex justify-between items-center p-4 bg-gray-50 hover:bg-gray-100 focus:outline-none"
                    onClick={() => toggleSection('nri')}
                  >
                    <div className="flex items-center">
                      <MapPin className="h-5 w-5 text-purple-500 mr-2" />
                      <span className="font-medium">Non-Resident Indians (NRIs)</span>
                    </div>
                    {expandedSection === 'nri' ? (
                      <ChevronUp className="h-5 w-5 text-gray-500" />
                    ) : (
                      <ChevronDown className="h-5 w-5 text-gray-500" />
                    )}
                  </button>
                  
                  {expandedSection === 'nri' && (
                    <div className="p-4 bg-white">
                      <ul className="ml-8 list-disc text-gray-700 space-y-2">
                        <li>NRIs are eligible to open Demat accounts using NRE (Non-Resident External) or NRO (Non-Resident Ordinary) accounts, in compliance with FEMA regulations.</li>
                        {/* <li>Must comply with FEMA regulations</li>
                        <li>Overseas address proof required</li>
                        <li>Foreign bank account details needed</li> */}
                      </ul>
                    </div>
                  )}
                </div>
                {/*  Occupations */}
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  <button
                    className="w-full flex justify-between items-center p-4 bg-gray-50 hover:bg-gray-100 focus:outline-none"
                    onClick={() => toggleSection('oqu')}
                  >
                    <div className="flex items-center">
                      <MapPin className="h-5 w-5 text-purple-500 mr-2" />
                      <span className="font-medium">Individuals from All Occupations</span>
                    </div>
                    {expandedSection === 'oqu' ? (
                      <ChevronUp className="h-5 w-5 text-gray-500" />
                    ) : (
                      <ChevronDown className="h-5 w-5 text-gray-500" />
                    )}
                  </button>
                  
                  {expandedSection === 'oqu' && (
                    <div className="p-4 bg-white">
                      <ul className="ml-8 list-disc text-gray-700 space-y-2">
                        <li>Salaried professionals, students, homemakers, and retirees can open a Demat account without any restriction on income or employment status.</li>
                        {/* <li>Must comply with FEMA regulations</li>
                        <li>Overseas address proof required</li>
                        <li>Foreign bank account details needed</li> */}
                      </ul>
                    </div>
                  )}
                </div>
                {/* Corporate Category */}
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  <button
                    className="w-full flex justify-between items-center p-4 bg-gray-50 hover:bg-gray-100 focus:outline-none"
                    onClick={() => toggleSection('corporate')}
                  >
                    <div className="flex items-center">
                      <FileText className="h-5 w-5 text-orange-500 mr-2" />
                      <span className="font-medium">Corporate Entities</span>
                    </div>
                    {expandedSection === 'corporate' ? (
                      <ChevronUp className="h-5 w-5 text-gray-500" />
                    ) : (
                      <ChevronDown className="h-5 w-5 text-gray-500" />
                    )}
                  </button>
                  
                  {expandedSection === 'corporate' && (
                    <div className="p-4 bg-white">
                      <ul className="ml-8 list-disc text-gray-700 space-y-2">
                        <li>Companies, trusts, and partnerships can open Demat accounts for investment and trading purposes. The documentation differs from that of individual accounts.</li>
                        {/* <li>Registration/incorporation documents required</li>
                        <li>Board resolution authorizing the account opening</li>
                        <li>KYC of authorized signatories needed</li> */}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Documents Content */}
        {activeTab === 'documents' && (
          <div>
            <div className="bg-white rounded-lg shadow-md p-6 mb-8">
              <p className="text-gray-700 mb-6">
              The account opening process is paperless with most modern brokers, but it still requires specific documents for KYC (Know Your Customer) verification. These documents are mandatory under SEBI guidelines and help ensure the legitimacy of account holders. Here's what you typically need:
              </p>
              
              <div className="grid gap-6 mt-8">
                {/* POI Section */}
                <div className="border border-gray-200 rounded-lg p-6 bg-white shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <User className="h-8 w-8 p-1 rounded-full bg-blue-100 text-blue-600" />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium text-gray-900">Proof of Identity (POI)</h3>
                      <p className="mt-2 text-gray-600">
                      A government-issued photo ID is required to confirm the applicant’s identity. This can include:
                      </p>
                      <ul className="mt-3 space-y-2">
                        {['Aadhaar Card', 'PAN Card (mandatory)', 'Passport', 'Voter ID', 'Driving License'].map((item, index) => (
                          <li key={index} className="flex items-center">
                            <Check className="h-4 w-4 text-green-500 mr-2" />
                            <span className="text-gray-700">{item}</span>
                          </li>
                        ))}
                      </ul>
                      <p className="mt-3 text-gray-600 font-medium">
                        Note: While multiple identity documents can be submitted, the PAN card is compulsory, as it's essential for taxation and stock market transactions.
                      </p>
                    </div>
                  </div>
                </div>

                {/* POA Section */}
                <div className="border border-gray-200 rounded-lg p-6 bg-white shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <MapPin className="h-8 w-8 p-1 rounded-full bg-green-100 text-green-600" />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium text-gray-900">Proof of Address (POA)</h3>
                      <p className="mt-2 text-gray-600">
                      To verify your current residence, you must provide a document that clearly shows your name and address. Acceptable proofs include:
                      </p>
                      <ul className="mt-3 space-y-2">
                        {[
                          'Aadhaar Card',
                          'Utility bills (electricity, water, gas) not older than 3 months',
                          'Bank statement or passbook (latest 3 months, with IFSC code and stamp)',
                          'Passport',
                          'Driving License',
                          'Registered Rent Agreement'
                        ].map((item, index) => (
                          <li key={index} className="flex items-center">
                            <Check className="h-4 w-4 text-green-500 mr-2" />
                            <span className="text-gray-700">{item}</span>
                          </li>
                        ))}
                      </ul>
                      <p className="mt-3 text-gray-600 font-medium">
                        Note: While multiple identity documents can be submitted, the PAN card is compulsory, as it's essential for taxation and stock market transactions.
                      </p>
                    </div>
                  </div>
                </div>

                {/* PAN Card Section */}
                <div className="border border-gray-200 rounded-lg p-6 bg-white shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <CreditCard className="h-8 w-8 p-1 rounded-full bg-purple-100 text-purple-600" />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium text-gray-900">PAN Card</h3>
                      {/* <p className="mt-2 text-gray-600">
                      This deserves a separate mention because, without a valid PAN card, your application cannot proceed. It must be active and not under any restrictions from the Income Tax Department
                      </p> */}
                      <ul className="mt-3 space-y-2">
                        <li className="flex items-center">
                          <Check className="h-4 w-4 text-green-500 mr-2" />

                          <span className="text-gray-700"> This deserves a separate mention because, without a valid PAN card, your application cannot proceed. It must be active and not under any restrictions from the Income Tax Department
                          </span>
                          {/* <span className="text-gray-700">Active and valid</span> */}
                        </li>
                        {/* <li className="flex items-center">
                          <Check className="h-4 w-4 text-green-500 mr-2" />
                          <span className="text-gray-700">Not under any restrictions from Income Tax Department</span>
                        </li>
                        <li className="flex items-center">
                          <Check className="h-4 w-4 text-green-500 mr-2" />
                          <span className="text-gray-700">Linked to your mobile number and Aadhaar (preferred)</span>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Bank Proof Section */}
                <div className="border border-gray-200 rounded-lg p-6 bg-white shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <Landmark className="h-8 w-8 p-1 rounded-full bg-blue-100 text-blue-600" />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium text-gray-900">Bank Proof</h3>
                      <p className="mt-2 text-gray-600">
                      You’ll be required to link a bank account to your Demat account for seamless fund transfers. For this, you may need to submit:
                      </p>
                      <ul className="mt-3 space-y-2">
                        <li className="flex items-center">
                          <Check className="h-4 w-4 text-green-500 mr-2" />
                          <span className="text-gray-700">A cancelled cheque with your name printed</span>
                        </li>
                        <li className="flex items-center">
                          <Check className="h-4 w-4 text-green-500 mr-2" />
                          <span className="text-gray-700">Latest bank statement or passbook copy</span>
                        </li>
                      </ul>
                      <p className="mt-3 text-gray-600 font-medium">
                        Note: This ensures your trading and withdrawal activities are secure and traceable.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Income Proof Section */}
                <div className="border border-gray-200 rounded-lg p-6 bg-white shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <DollarSign className="h-8 w-8 p-1 rounded-full bg-yellow-100 text-yellow-600" />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium text-gray-900">Income Proof (for Derivatives Trading Only)</h3>
                      <p className="mt-2 text-gray-600">
                      If you wish to trade in derivatives (Futures and Options), you must provide proof of income. Acceptable documents include:
                      </p>
                      <ul className="mt-3 space-y-2">
                        {[
                          'Last 6-month bank statement',
                          'Latest salary slip',
                          'Income Tax Return (ITR) acknowledgment',
                          'Demat holding statement'
                        ].map((item, index) => (
                          <li key={index} className="flex items-center">
                            <Check className="h-4 w-4 text-green-500 mr-2" />
                            <span className="text-gray-700">{item}</span>
                          </li>
                        ))}
                      </ul>
                      <p className="mt-3 text-gray-600">
                        Note: For equity trading or investing in stocks and mutual funds, income proof is generally not required.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Photo and Signature Section */}
                <div className="border border-gray-200 rounded-lg p-6 bg-white shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <Camera className="h-8 w-8 p-1 rounded-full bg-red-100 text-red-600" />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium text-gray-900">Photograph and Signature</h3>
                      {/* <p className="mt-2 text-gray-600">
                        Used for identity matching and document authentication:
                      </p> */}
                      <ul className="mt-3 space-y-2">
                        <li className="flex items-center">
                          <Check className="h-4 w-4 text-green-500 mr-2" />
                          <span className="text-gray-700">   You’ll be asked to upload a recent passport-size photograph and provide a digital or scanned signature. This is typically used for identity matching and document authentication.
                         </span>
                          {/* <span className="text-gray-700">Recent passport-size photograph</span> */}
                        </li>
                        {/* <li className="flex items-center">
                          <Check className="h-4 w-4 text-green-500 mr-2" />
                          <span className="text-gray-700">Digital or scanned signature</span>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div></div>
        )}
      </div>
    </div>
      {/* FAQ section */}
      <div className="max-w-4xl mx-auto py-6 mt-10 p-6">
        <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default DematMainPage;
